<footer
    class="relative flex flex-col bg-black border-t-[#b27939] border-t-4 w-full text-white ~py-8/12"
>
    <div class="gap-8 grid grid-cols-1 md:grid-cols-4 mx-auto w-4/5">
        <div class="flex flex-col justify-between items-start gap-8">
            <img
                src="/images/Logo_Zehentmoar_RGB.svg"
                alt="logo hof zehentmoar"
                class="object-contain ~h-24/24"
            />
            <h3 class="~text-lg/3xl">steak it easy.</h3>
        </div>

        <div class="lg:justify-self-center">
            <h3 class="font-semibold text-xl">Quick Links</h3>
            <ul class="space-y-2 mt-4">
                @for (
                    item of footerData.value()?.data?.footerItems;
                    track $index
                ) {
                    <li>
                        <a
                            routerLink="/{{
                                languageService.getLanguageCode
                            }}/{{ item.linkItem.link }}"
                            (click)="
                                umami.track('footer-link-click', {
                                    link: item.linkItem.link,
                                    text: item.linkItem.text,
                                })
                            "
                            class="text-gray-400 hover:text-white transition"
                            >{{ item.linkItem.text }}</a
                        >
                    </li>
                }
            </ul>
        </div>
        @if (footerData.value()?.data?.map) {
            <app-map
                [data]="footerData.value()!.data!.map"
                class="m-0 p-0 w-full h-full"
            ></app-map>
        }

        <div>
            <h3 class="font-semibold text-xl">Newsletter</h3>
            <p class="mt-2 text-neutral-400">
                {{ "newsletter.subscribeToOurNewsletter" | translate }}
            </p>
            <div class="flex mt-2">
                <app-newsletter-input-field
                    colorMode="white"
                ></app-newsletter-input-field>
            </div>
            <h3 class="mt-6 font-semibold text-xl">Meat us on:</h3>
            <div class="flex space-x-4 mt-2">
                <app-social-media-links
                    [withFill]="true"
                    class="fill-white"
                ></app-social-media-links>
            </div>
        </div>
    </div>

    <div class="flex justify-between mx-auto pt-6 w-4/5 text-xs sm:text-sm">
        <p>&copy; {{ currentYear }} HOF ZEHENTMOAR</p>
        <div class="~space-x-2/4">
            <a
                class="inline-flex gap-x-2 focus:outline-none hover:text-gray-200 focus:text-gray-200"
                [routerLink]="[
                    '/',
                    this.languageService.getLanguageCode,
                    'hof',
                    'impressum',
                ]"
            >
                {{ "footer.imprint" | translate }}
            </a>
            <span>|</span>
            <a
                class="inline-flex gap-x-2 focus:outline-none hover:text-gray-200 focus:text-gray-200"
                [routerLink]="[
                    '/',
                    this.languageService.getLanguageCode,
                    'hof',
                    'datenschutz',
                ]"
            >
                {{ "footer.dataProtection" | translate }}
            </a>
            <span>|</span>
            <a
                class="inline-flex gap-x-2 focus:outline-none hover:text-gray-200 focus:text-gray-200"
                [routerLink]="[
                    '/',
                    this.languageService.getLanguageCode,
                    'hof',
                    'agb',
                ]"
            >
                {{ "footer.termsAndConditions" | translate }}
            </a>
        </div>
    </div>
</footer>
